export default __webpack_public_path__ + "d24e07684d64604e56ab0fb3fcefd9b7.png";